import { useState, useEffect } from "react";
import { callApi } from "../../services/ApiServices";
import CommonPagination from "../common/CommonPagination";
import toast from "react-hot-toast";
import { ImagePath } from "../common/ImagePath";
import { useGlobalStates } from "../../utlis/ClubsContext";
import { UserRole } from "../../utlis/constant";
import CommonLoader from "../common/CommonLoader";
import { useNavigate } from "react-router-dom";

const AdvertiserList = ({ onUserClick }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [advertiserList, setAdvertiserList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 10;
  const {userRole} = useGlobalStates()
  const navigation = useNavigate()

  useEffect(() => {
    fetchAdvertiserList(currentPage, limit, searchQuery);
  }, []);


  const fetchAdvertiserList = async (page, limit, search) => {
    const trimmedSearch = search?.trim();
    if (search && !trimmedSearch) {
      return;
    }
    if (!search) {
      setLoading(true);
    }
    try {
      let apiUrl = `users/advertisers?page=${page}&limit=${limit}`;
      if (search) {
        apiUrl += `&search=${search}`;
      }
      const response = await callApi({
        method: "get",
        url: apiUrl,
      });
      console.log("adviser Response", response);
      if (response.status === 200) {
        setAdvertiserList(response?.data);
        const totalItems = response?.pagination?.total;
        const totalPages = Math.ceil(totalItems / limit);
        setTotalCount(totalPages);
      }
    } catch (error) {
      console.log("error while fetching advisor list", error);
    } finally {
      setLoading(false);
    }
  };

  const OnPageChange = (e) => {
    setCurrentPage(e);
    fetchAdvertiserList(e, limit, searchQuery);
  };

  const toggleStatus = async (status, id) => {
    const newStatus = status === "active" ? "inactive" : "active";
    // setLoading(true)
    try {
      const response = await callApi({
        method:"PATCH",
        url:`users/status?userId=${id}`,
        data:{
          status:newStatus
        }
      })
      if(response.status === 200){
      toast.success(response?.message ,{id:"toggleStatusToast"})
      setAdvertiserList((prev) =>
        prev.map((item) => {
          console.log("first", item.id, id);
          return item.id === id ? { ...item, status: newStatus } : item;
        }),
      );
      }
    } catch (error) {
      console.log("error while toggling status", error);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Search Bar */}
      {isLoading && <CommonLoader fullScreen />}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 max-w-[314px]">
        <div className="relative">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textcolor"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            type="search"
            placeholder="Search by name and email..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
              fetchAdvertiserList(1, limit, e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === " " && searchQuery?.length === 0) {
                e.preventDefault();
              }
            }}
            className="w-full pl-10 pr-4 py-2.5 border-0 focus:outline-none text-base text-textcolor placeholder:text-textcolor"
          />
        </div>
      </div>

      {/* Advertisers Table */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#fafafa] border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  User Id
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Total Orders
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {advertiserList?.length > 0 ? (
                advertiserList?.map((advertiser, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td
                      className="px-6 py-3 cursor-pointer"
                      onClick={() =>
                        navigation(`/advertiser-details/${advertiser?.id}`) 
                      }
                    >
                      <span className="text-sm font-medium text-blue-700 hover:text-primary underline underline-offset-4">
                        {advertiser.id || "-"}
                      </span>
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {advertiser.name || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {advertiser.email || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {advertiser.totalOrders || "-"}
                    </td>
                    <td className="px-6 py-3">
                      {/* <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={advertiser.status || "-"}
                        onChange={() => {}}
                        className="sr-only peer"
                        onClick={()=>toggleStatus(advertiser.status,advertiser.id)}
                      />
                      <div className={`w-11 h-6 bg-[#DEDEDE] rounded-full peer ${} peer-checked:bg-[#4CAF50] peer-checked:after:translate-x-5 after:content-['']
                       after:absolute after:top-0.5 after:left-[2px] after:bg-[#E8F5E9] after:rounded-full after:h-5 after:w-5 after:transition-all`}></div>
                    </label> */}

                      <button
                        type="button"
                        disabled={userRole === UserRole.Viewer}
                        onClick={() =>
                          toggleStatus(advertiser.status, advertiser.id)
                        }
                        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-300 focus:outline-none 
                          ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
                       ${advertiser.status === "active" ? "bg-[#4CAF50]" : "bg-gray-300"}
                      `}
                      >
                        <span
                          className={`inline-block h-3.5 w-3.5 rounded-full bg-white transform transition-transform duration-300
                        ${advertiser.status === "active" ? "translate-x-5" : "translate-x-1"}
                      `}
                        />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="px-6 py-10 text-center">
                    <div className="flex justify-center items-center">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2">No User found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <CommonPagination
        currentPage={currentPage}
        pageCount={totalCount}
        onPageChange={OnPageChange}
      />
    </div>
  );
};

export default AdvertiserList;
